module.exports = __webpack_public_path__ + "img/facebook-logo.5d6ea38a.png";